import { render, staticRenderFns } from "./AppCarouselSlideDetails.vue?vue&type=template&id=9a5e2b50&scoped=true&"
import script from "./AppCarouselSlideDetails.vue?vue&type=script&lang=js&"
export * from "./AppCarouselSlideDetails.vue?vue&type=script&lang=js&"
import style0 from "./AppCarouselSlideDetails.vue?vue&type=style&index=0&id=9a5e2b50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5e2b50",
  null
  
)

export default component.exports